import React from "react";
import { Check } from "lucide-react";

const items = [
  "Deixar suas entregas mais bonitas e profissionais",
  "Encantar suas clientes e fazer com que elas lembrem da sua marca",
  "Valorizar seus produtos para cobrar mais e lucrar melhor",
  "Economizar tempo usando artes prontas e organizadas",
  "Se destacar da concorrência com apresentações que realmente impressionam",
  "Vender kits completos, agregar valor e aumentar o ticket médio",
];

const IdealFor = () => {
  return (
    <section className="section-pad bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-serif-display font-black text-2xl md:text-5xl text-pink-700 leading-tight">
            Este material é ideal para você que deseja:
          </h2>
        </div>

        <ul className="mt-6 md:mt-10 grid md:grid-cols-2 gap-2.5 md:gap-4">
          {items.map((t, i) => (
            <li
              key={i}
              className="flex items-start gap-3 bg-pink-50/70 border border-pink-100 rounded-xl p-3 md:p-4 card-hover"
            >
              <span className="mt-0.5 w-6 h-6 md:w-7 md:h-7 shrink-0 rounded-full bg-pink-500 text-white grid place-content-center shadow">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4" strokeWidth={3} />
              </span>
              <span className="text-pink-900 font-medium text-sm md:text-base">{t}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default IdealFor;
